import {
  PUBLIC_BROWSE_CACHE_INVALIDATION_MESSAGE,
  PUBLIC_BROWSE_CACHE_PREFIX,
  PUBLIC_BROWSE_SERVICE_WORKER_PATH,
} from "./public-browse-service-worker";

export async function registerPublicBrowseServiceWorker(): Promise<void> {
  if (
    import.meta.env.DEV ||
    typeof window === "undefined" ||
    !window.isSecureContext ||
    !("serviceWorker" in navigator)
  ) {
    return;
  }
  const release = document
    .querySelector<HTMLMetaElement>('meta[name="glider-release-sha"]')
    ?.content.trim();
  if (!release || release === "development") return;

  try {
    await navigator.serviceWorker.register(PUBLIC_BROWSE_SERVICE_WORKER_PATH, {
      scope: "/",
      updateViaCache: "none",
    });
  } catch {
    // This optional repeat-navigation cache must not affect app startup.
  }
}

async function pauseActivePublicBrowseCache(): Promise<void> {
  if (typeof navigator === "undefined" || !("serviceWorker" in navigator)) {
    return;
  }
  const controller = navigator.serviceWorker.controller;
  if (
    !controller ||
    new URL(controller.scriptURL).pathname !== PUBLIC_BROWSE_SERVICE_WORKER_PATH
  ) {
    return;
  }
  const message = { type: PUBLIC_BROWSE_CACHE_INVALIDATION_MESSAGE };
  if (typeof MessageChannel === "undefined") {
    controller.postMessage(message);
    return;
  }
  await new Promise<void>((resolve) => {
    const channel = new MessageChannel();
    const finish = () => {
      clearTimeout(timeout);
      channel.port1.close();
      channel.port2.close();
      resolve();
    };
    const timeout = setTimeout(finish, 250);
    channel.port1.onmessage = finish;
    controller.postMessage(message, [channel.port2]);
  });
}

export async function clearPublicBrowseServiceWorkerCache(): Promise<void> {
  try {
    // Pause the active worker before clearing storage, so its in-flight
    // revalidation cannot refill stale HTML immediately before a recovery reload.
    await pauseActivePublicBrowseCache();
    if (typeof caches === "undefined") return;
    const names = await caches.keys();
    await Promise.all(
      names
        .filter((name) => name.startsWith(PUBLIC_BROWSE_CACHE_PREFIX))
        .map((name) => caches.delete(name)),
    );
  } catch {
    // Reload still proceeds when browser storage or service workers are blocked.
  }
}
